export const redcloudPlans = [
  {
    key: 'starter',
    name: 'Starter',
    storageTb: 3,
    monthlyPriceUsd: 29.99,
    includedMonthlyTransfer: '250GB'
  },
  {
    key: 'growth',
    name: 'Growth',
    storageTb: 10,
    monthlyPriceUsd: 54.99,
    includedMonthlyTransfer: '500GB'
  },
  {
    key: 'studio',
    name: 'Studio',
    storageTb: 25,
    monthlyPriceUsd: 134.99,
    includedMonthlyTransfer: '750GB'
  },
  {
    key: 'pro',
    name: 'Pro',
    storageTb: 50,
    monthlyPriceUsd: 269.99,
    includedMonthlyTransfer: '1TB'
  }
];

export const redcloudAddOns = [
  {
    key: 'client-of-client-management',
    name: 'Customer Storage & Gallery',
    monthlyPriceUsd: 2.99,
    includedStorageGb: 300,
    accessLevel: 'view-only'
  }
];
